module.exports = __webpack_public_path__ + "static/img/witness-kids-7.44322a2f.png";